import React from 'react'
import USER_TYPE from '../../../constants/userType'

const messages = {
  [USER_TYPE.customer]: {
    title: 'Why Sokooni for Customers?',
    description:
      'Join Sokooni and shop from the best sellers in your area. Whether you’re a customer or a business owner, Sokooni has you covered. With our user-friendly platform, reliable delivery, and customer support, you can shop with confidence and enjoy a seamless shopping experience.',
  },
  [USER_TYPE.retailer]: {
    title: 'Why Sokooni for Retailers?',
    description:
      'Join Sokooni and showcase your products to a wide customer base. Whether you’re a retailer or wholesaler, Sokooni has you covered. With our user-friendly platform, reliable delivery, and customer support, you can reach more customers and grow your business.',
  },
  [USER_TYPE.wholeseller]: {
    title: 'Why Sokooni for Wholesellers?',
    description:
      'Join Sokooni and connect with customers from around the world. Whether you’re a wholesaler or a business owner, Sokooni has you covered. With our user-friendly platform, reliable delivery, and customer support, you can reach more customers and grow your business.',
  },
}

const StepWhySokooni = ({ onNext, userType }) => {
  const { title, description } = messages[userType]
  return (
    <div className="flex flex-col items-center gap-5">
      <div className="px-4 py-4 bg-gradient-to-b from-[#FAB246] to-[#EF8E00] rounded-[37px] ">
        <img
          src="/customer-signup-image.png"
          alt="Products"
          className="w-[250px]  object-contain rounded-[17.7px]"
        />
      </div>
      <h2 className="mt-8 w-[278px]  text-[24px] leading-[29px] font-extrabold text-black text-center">
        {title}
      </h2>
      <p className=" text-[18px] leading-[22px] text-black/60 text-center">{description}</p>
      <button
        className="mt-10 w-3/4 mb-10 py-3  bg-gradient-to-r from-[#DE8516] to-[#F08A0A] shadow-md rounded-[10px] text-white text-[18px] font-medium  capitalize"
        style={{ boxShadow: '0px 4px 4px rgba(0,0,0,0.25)' }}
        onClick={() => onNext({})}
      >
        NEXT
      </button>
    </div>
  )
}

export default StepWhySokooni
